import { render, staticRenderFns } from "./floatingButton.vue?vue&type=template&id=506daf6c&scoped=true"
import script from "./floatingButton.vue?vue&type=script&lang=js"
export * from "./floatingButton.vue?vue&type=script&lang=js"
import style0 from "./floatingButton.vue?vue&type=style&index=0&id=506daf6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506daf6c",
  null
  
)

export default component.exports